export default __webpack_public_path__ + "static/coming-soon-73b26358d396b7c9f30f4135a49844b6.png";